import ReactPaginate from 'react-paginate';
import styles from './pagination.module.scss';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { InputBar } from '../InputBar/InputBar';
import { numberValidate } from '~/utils/regex';

interface SelectedPage {
  selected: number;
}

interface PaginationProps {
  forcePage?: number;
  pageCount: number;
  onPageChange: (selectedPage: SelectedPage) => void;
  searchParam?: string;
}

export const Pagination = ({
  forcePage = 1,
  pageCount,
  onPageChange,
  searchParam = 'paginate',
}: PaginationProps): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  const handlePageChange = (selectedPage: SelectedPage) => {
    const newPage = selectedPage.selected + 1;
    searchParams.set(searchParam, newPage.toString());
    setSearchParams(searchParams);
    onPageChange(selectedPage);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (!value) {
      searchParams.delete(searchParam);
      setSearchParams(searchParams);
      onPageChange({ selected: 0 });
      return;
    }

    if (
      numberValidate(value) &&
      Number(value) <= pageCount &&
      Number(value) >= 1
    ) {
      searchParams.set(searchParam, value);
      setSearchParams(searchParams);
      onPageChange({ selected: Number(value) - 1 });
    }
  };

  return (
    <div className={styles.pagination}>
      <ReactPaginate
        forcePage={forcePage - 1}
        previousLabel={t('back')}
        nextLabel={t('forward')}
        pageCount={pageCount}
        onPageChange={handlePageChange}
        containerClassName={styles.paginationBtns}
        previousLinkClassName={styles.previousBtn}
        nextLinkClassName={styles.nextBtn}
        disabledClassName={styles.paginationDisabled}
        activeClassName={styles.paginationActive}
      />
      {pageCount > 1 && (
        <InputBar
          classNameInput={styles.paginationInput}
          value={searchParams.get(searchParam) || ''}
          onChange={handleInputChange}
        />
      )}
    </div>
  );
};
